webpackJsonp([35783957827783],{

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FixedSize = function FixedSize(_ref) {
	    var restrict = _ref.restrict,
	        children = _ref.children;
	    return _react2.default.createElement(
	        'div',
	        { className: 'fixed-size-container' },
	        _react2.default.createElement(
	            'div',
	            { className: 'fixed-size' },
	            _react2.default.createElement(
	                'div',
	                { className: restrict === true ? 'fixed-size-restrict' : '' },
	                children
	            )
	        )
	    );
	};
	
	FixedSize.defaultProps = {
	    restrict: true
	};
	
	FixedSize.propTypes = {
	    children: _propTypes2.default.object,
	    restrict: _propTypes2.default.bool
	};
	
	exports.default = FixedSize;
	module.exports = exports['default'];

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(36);
	
	var _FixedSize = __webpack_require__(42);
	
	var _FixedSize2 = _interopRequireDefault(_FixedSize);
	
	var _intro = __webpack_require__(527);
	
	var _intro2 = _interopRequireDefault(_intro);
	
	var _intro3 = __webpack_require__(528);
	
	var _intro4 = _interopRequireDefault(_intro3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	    _inherits(Index, _Component);
	
	    function Index() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Index);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.toMenu = function () {
	            (0, _gatsbyLink.navigateTo)('/menu');
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Index.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'vertical-center',
	                style: { backgroundColor: '#f8f8f8' } },
	            _react2.default.createElement(
	                'video',
	                { style: { width: '100%', height: '100%' },
	                    onError: this.toMenu,
	                    onEnded: this.toMenu,
	                    autoPlay: true, muted: true },
	                _react2.default.createElement('source', { src: _intro2.default, type: 'video/mp4' }),
	                _react2.default.createElement('source', { src: _intro4.default, type: 'video/webm' })
	            )
	        );
	    };
	
	    return Index;
	}(_react.Component);
	
	exports.default = Index;
	module.exports = exports['default'];

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/intro.309cfd4a.mp4";

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/intro.50c630a6.webm";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-eef1c9fc5ca240a92f1e.js